import { getRequest, postRequest } from '@/utils/fetch';

// 获取 登陆 token
export const getLoginToken = (cno: string) => {
    return getRequest('/work-order/workOrder/hotline/cc/wsAgentToken', { cno });
};

/**
 * 获取置忙状态
 * @returns
 */
export const getPausesStatus = () => {
    return getRequest('/work-order/workOrder/hotline/cc/listEnterprisePauses');
};

// 获取话机列表
export const getIpList = (params: {
    current: number;
    pageSize: number;
    type: number;
}) => {
    return postRequest('/work-order/workOrder/hotline/cc/listExtens', params);
};

// 获取坐席详情
export const getAgentDetail = (cno: string) => {
    return getRequest('/work-order/workOrder/hotline/cc/describeClient', {
        cno,
    });
};

// 获取队列排队数量
export const getQueueStatus = (qnos: string[]) => {
    return postRequest('/work-order/workOrder/hotline/cc/queueStatus', {
        qnos,
        statusScope: 'queueEntries',
    });
};

// 获取ivr 列表
export const getIvrs = (ivrName: string) => {
    return getRequest('/work-order/workOrder/hotline/cc/listIvrNodes', {
        ivrName,
    });
};

// 获取 队列列表
export const getQueues = () => {
    return getRequest('/work-order/workOrder/hotline/cc/listQueues');
};

// 获取 队列 下的坐席列表
export const getClientsByQno = (qno: string) => {
    return getRequest('/work-order/workOrder/hotline/cc/listClients', { qno });
};

// 获取通话录音文件链接
export const getFileUrl = (mainUniqueId: string) => {
    return getRequest('/work-order/workOrder/hotline/cc/downloadRecordFile', {
        mainUniqueId,
    });
};

// 通话结束记录通话
export const recordCall = (params: {
    sessionId: string;
    sessionType: number;
    popId: string;
    workOrderNo?: string;
}) => {
    return postRequest('/work-order/workOrder/hotline/call', params);
};

// 获取呼入通话详情
export const getCdrIbDetails = (mainUniqueId: string) => {
    return getRequest('/work-order/workOrder/hotline/cc/cdrIbDetails', {
        mainUniqueId,
    });
};
